import React from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Form from './Form';

export default function Popup({ row, show, onHide }) {
  // const { dispatch, actions, state } = useAdminContext();

  return (
    <Modal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Change Invoice Type
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form row={row} onHide={onHide} />
      </Modal.Body>
    </Modal>
  );
}

Popup.propTypes = {
  row: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
